import styled from 'styled-components'
import { Spin } from 'antd'

const VeritasSpinner = styled(Spin)`
    & .ant-spin-dot-item {
        background-color: #7BAD7E
    }
`

export default VeritasSpinner
